module.exports = __webpack_public_path__ + "images/emoji/hurtrealbad.3a9763040f4d724ecbd5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hurtrealbad.png
// module id = 9OPr
// module chunks = 2